import { Grid, Paper, Typography } from '@mui/material';
import { SecondaryTitle } from 'src/shared/components/atoms/secondaryTitle';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { useTranslation } from 'react-i18next';
import { useStatisticsContext } from 'src/shared/contexts/statisticsContext';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';
import { StatisticsFilterDatePicker } from './statisticsFilterDatePicker';
import { StatisticsChartLine } from './statisticsChartLine';
import { StatisticsContentHeader } from './statisticsContentHeader';
import { StatisticsPaymentDistributionContent } from './statisticsPaymentDistributionContent';
import { useFetchPaymentDistribution } from '../hooks/useFetchPaymentDistribution';

export const StatisticsPaymentDistributionOverview = () => {
  const { t } = useTranslation();
  const { paymentDistSearchFilter } = useStatisticsContext();
  const { paymentDistribution, chartData, isLoading } = useFetchPaymentDistribution(paymentDistSearchFilter, t('statistics:payments.labels.amount'));

  return (
    <Paper sx={{ height: '100%' }}>
      <SecondaryTitle title={t('statistics:payments.title')} divider uppercase />
      <PageFilterSection
        leftContent={
          <Grid container spacing={2}>
            <StatisticsFilterDatePicker />
          </Grid>
        }
      />
      <Grid container p={4} pb={2} flexGrow={1}>
        <Grid item xs={12} lg={8}>
          <Grid item xs={12}>
            <StatisticsContentHeader
              title={t('statistics:payments.sideTitle')}
              subtitleComponent={
                <Typography sx={{ display: 'inline' }} variant='h4' fontWeight={(thm) => thm.typography.fontWeightBold}>
                  <AmountWithCurrency amount={paymentDistribution?.totalAmount ?? 0} decimals={0} showCurrencyInSecondaryStyle currencyVariant='h5' />
                </Typography>
              }
              isLoading={isLoading}
            />
          </Grid>
          <Grid item xs={12}>
            <StatisticsChartLine chartData={chartData} isLoading={isLoading} />
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4} mb={1}>
          <StatisticsPaymentDistributionContent paymentDistribution={paymentDistribution} isLoading={isLoading} />
        </Grid>
        {/* <Grid item xs={12} mt={1} height='100%' flexGrow={1}>
          <Button variant='text' size='small' onClick={navigateHandler} endIcon={<ArrowForwardIos fontSize='inherit' />}>
            {t('common:button.showMore')}
          </Button>
        </Grid> */}
      </Grid>
    </Paper>
  );
};
